import Congrats from '@/components/congrats';
import ButtonStyle from '@/styles/components/button/_index.module.scss';
import PopupStyle from '@/styles/components/congrats/_index.module.scss';
import Button from '@/components/button'
import {cancelJob, useRouter, Image} from '@/imports-files/pages/clients/jobs/common'
import {REDIRECT, useTranslation } from '@/imports-files/common/common';
import {ConfirmationModalStyle, Close} from "@/imports-files/components/common-modal/common-modal";
import Modal from "@/components/common-modal/modal";

export default function BacktoAllJobs(props){
  const setCancelPopup = props.setCancelPopup;
  const router = useRouter();
  const {t} = useTranslation()
  return (
     <Congrats trigger={props.trigger} heightClass  =   'confirmcontainer'>
              {props.save_as_draft &&
                <span className={`${PopupStyle.Modalpopup__CloseCenter}`} onClick={() => {props.setCancelPopup(false);}}>
                    <Close />
                </span>
              }

             <div className={`${ConfirmationModalStyle.Modal__Container__Text} mt30`}>
              <span>{t('modal:confirmation:unsaved_changes')}</span>

              <div className={`${ConfirmationModalStyle.Modal__Container__ButtonSection} ${ConfirmationModalStyle.Modal__ButtonWidth}`}>

                <Button buttonstyle={`${ConfirmationModalStyle.primarybtn}`} onClick={()=> cancelJob(router, setCancelPopup, props.setPageName, props.queryClient)}>
                  {t('back:all_jobs')}
                </Button>

                <span>&nbsp;</span>

               
                {
                  props.save_as_draft ? 
                  <Button buttonstyle={`${ConfirmationModalStyle.secondarybtn} `}
                        onClick={ async (event)=> {
                                        event.preventDefault();
                                        await props.setSubmitState('draft');
                                        await props.formRef?.current?.validateForm();
                                        await props.formRef?.current?.submitForm();
                                        setCancelPopup(false);
                                       }} >

{t('button:save_as_draft')}
                </Button>:
                <Button buttonstyle={`${ConfirmationModalStyle.secondarybtn} `} onClick={()=> {setCancelPopup(false)}} >
                {t('button:cancel')}
                  </Button>}

              </div>  
        </div>
       </Congrats>
  )
}

